<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="front-title"><i>To Dagfinn Kjeholt and Peter Taylor</i></p>
<p class="front-para">Maritime power is the means whereby we control the sea for our own purposes … but it is safe to say that no factor is more influential than the quality and training of the men who handle and fight the instruments.</p>
<p class="front-right">Steven Roskill<br/><i>The Navy at War 1939–1945</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?b4c774fe